import { Link } from "react-router-dom";

export default function ProjectCardSmall (props){

let imgStyle = {
  maxHeight: '80px',
  objectFit: 'contain',
  marginTop: '5px',
}

let h5Style = {
    fontSize: '18px',
    fontWeight: '700',
    textAlign: 'center',
    margin: '0'
  }

let pStyle = {
  fontSize: '16px',
  fontWeight: '500',
  textAlign: 'left',
  margin: '3px 0 0 0'
}



return (
  <>
    <Link
       onClick={()=>props.setProjectModal(props.project_id)}
       to={"/projectdetails"}
       style={{textDecoration: 'none', color: "inherit"}}
      >
      <div
        className='hoverCard'
        key={props.project_id}
        style={{
          background: '#FFF',
          border: 'none',
          borderRadius: '10px',
          width: '300px',
          padding: '10px',
          margin: '20px 10px 10px 0px',
          // boxShadow: '0 4px 8px 0 rgba(0, 0, 0, .2), 0 3px 10px 0 rgba(0, 0, 0, .15)',
          cursor: 'pointer',
        }}
        onClick={() => props.setProjectModal(props.project_id)}
      >
        <div style = {{display: 'flex', justifyContent: 'center'}}>
          <img
            style = {imgStyle}
            src={`./icons/${props.specialty.replace(/\s+/g, "")}.png`}
            alt={props.specialty}/>
        </div>
        <hr style = {{borderTop: '1px solid #8c8b8b'}}/>
        <h5 style = {h5Style}>
          {props.title}
        </h5>
        <hr style = {{borderTop: '1px solid #8c8b8b'}}/>
        <div style = {{padding: '5px 5px 15px 10px'}}>
          <p style = {pStyle}>
            <strong>Residency program:</strong> {props.institution}
          </p>
          <p style = {pStyle}>
            <strong>Specialty:</strong> {props.specialty}
          </p>
          <p style = {pStyle}>
            <strong>Planned completion:</strong> {props.completion}
          </p>
        </div>
      </div>
    </Link>
  </>
)
}
